var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"copyright"},[_c('p',{staticClass:"text-grey"},[_vm._v(" "+_vm._s(_vm.$t("COPYRIGHT"))+" © 2022 "+_vm._s(_vm.RESERVED_KEYWORD)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }